export enum TelemetryProvider {
    DeltaTrack = "DeltaTrack",
    DeltaTrackShipment = "DeltaTrackShipment",
    Cargobull = "Cargobull",
    Carrier = "Carrier",
    HardmanT = "HardmanT",
    Sensitech = "Sensitech",
    HardmanTZ = "HardmanTZ",
    User = "User",
    Manual = "Manual",
    Queclink = "Queclink",
    None = "None"
}